// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  orders: null,
  singleOrder: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false,
  isPrintLoading: false,
  isSingleLoading: false,
  orderCount: null,
  isCountLoading: false
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get orders */
export const getOrdersV2 = (state: Object = INITIAL_STATE, action: Object) => {
  return {
    ...state,
    isLoading: !action.print,
    isPrintLoading: action.print
  };
};

export const getOrdersV2Success = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  if (state.isPrintLoading) {
    return {
      ...state,
      printOrders: action.orders,
      isPrintLoading: false
    };
  } else {
    return {
      ...state,
      orders: action.orders,
      isLoading: false
    };
  }
};

export const getOrdersV2Failure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  isPrintLoading: false,
  errorMessage: action.error || genericError
});

/* Close ASN */
export const openPickup = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isClosing: true,
    successMessage: null,
    errorMessage: null
  };
};

export const openPickupSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = I18n.getText("orders.successful-request");
  return {
    ...state,
    close: action.close,
    successMessage,
    isClosing: false
  };
};

export const openPickupFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isClosing: false
  };
};

/* Get single order */
export const getSingleOrder = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isSingleLoading: true
  };
};

export const getSingleOrderSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    singleOrder: action.orders,
    isSingleLoading: false
  };
};

export const getSingleOrderFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isSingleLoading: false,
  errorMessage: action.error || genericError
});

/* Get orders */
export const getOrderCount = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isCountLoading: true
  };
};

export const getOrderCountSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    orderCount: action.orderCount,
    isCountLoading: false
  };
};

export const getOrderCountFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isCountLoading: false,
  errorMessage: action.error || genericError
});

/* Get Reserved orders */
export const postPickupV2 = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const postPickupV2Success = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    // orders: action.orders,
    isLoading: false
  };
};

export const postPickupV2Failure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* Post Orders */
export const postOrdersV2 = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const postOrdersV2Success = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Order success";
  return {
    ...state,
    orders: action.orders,
    successMessage,
    isLoading: false
  };
};

export const postOrdersV2Failure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isLoading: false
  };
};

/* Get orders */
export const printOrder = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isPrintLoading: true
  };
};

export const printOrderSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    isPrintLoading: false
  };
};

export const printOrderFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isPrintLoading: false,
  errorMessage: action.error || genericError
});

/******
*******
Deprecated orders

*****
******/

/* Get orders */
export const getOrders = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getOrdersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    orders: action.orders,
    isLoading: false
  };
};

export const getOrdersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* Get Reserved orders */
export const getReservedOrders = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getReservedOrdersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    orders: action.orders,
    isLoading: false
  };
};

export const getReservedOrdersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* Post Orders */
export const postOrders = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const postOrdersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Order success";
  return {
    ...state,
    orders: action.orders,
    successMessage,
    isLoading: false
  };
};

export const postOrdersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
    isLoading: false
  };
};

/******
End of Deprecated
****/

const ACTION_HANDLERS = {
  [Types.GET_ORDERS_V2]: getOrdersV2,
  [Types.GET_ORDERS_V2_SUCCESS]: getOrdersV2Success,
  [Types.GET_ORDERS_V2_FAILURE]: getOrdersV2Failure,
  [Types.GET_SINGLE_ORDER]: getSingleOrder,
  [Types.GET_SINGLE_ORDER_SUCCESS]: getSingleOrderSuccess,
  [Types.GET_SINGLE_ORDER_FAILURE]: getSingleOrderFailure,
  [Types.POST_ORDERS_V2]: postOrdersV2,
  [Types.POST_ORDERS_V2_SUCCESS]: postOrdersV2Success,
  [Types.POST_ORDERS_V2_FAILURE]: postOrdersV2Failure,
  [Types.POST_PICKUP_V2]: postPickupV2,
  [Types.POST_PICKUP_V2_SUCCESS]: postPickupV2Success,
  [Types.POST_PICKUP_V2_FAILURE]: postPickupV2Failure,
  [Types.PRINT_ORDER]: printOrder,
  [Types.PRINT_ORDER_SUCCESS]: printOrderSuccess,
  [Types.PRINT_ORDER_FAILURE]: printOrderFailure,
  [Types.GET_ORDERS]: getOrders,
  [Types.GET_ORDERS_SUCCESS]: getOrdersSuccess,
  [Types.GET_ORDERS_FAILURE]: getOrdersFailure,
  [Types.POST_ORDERS]: postOrders,
  [Types.POST_ORDERS_SUCCESS]: postOrdersSuccess,
  [Types.POST_ORDERS_FAILURE]: postOrdersFailure,
  [Types.GET_RESERVED_ORDERS]: getReservedOrders,
  [Types.GET_RESERVED_ORDERS_SUCCESS]: getReservedOrdersSuccess,
  [Types.GET_RESERVED_ORDERS_FAILURE]: getReservedOrdersFailure,
  [Types.GET_ORDER_COUNT]: getOrderCount,
  [Types.GET_ORDER_COUNT_SUCCESS]: getOrderCountSuccess,
  [Types.GET_ORDER_COUNT_FAILURE]: getOrderCountFailure,
  [Types.OPEN_PICKUP]: openPickup,
  [Types.OPEN_PICKUP_SUCCESS]: openPickupSuccess,
  [Types.OPEN_PICKUP_FAILURE]: openPickupFailure,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/OrdersReducer.js